import * as React from "react";
import { AriaPopoverProps, Overlay, usePopover } from "react-aria";
import { OverlayTriggerState } from "react-stately";
import { useTheme } from "../theme/theme-provider";
import { cx, mergeRefs } from "../../utils/dom";
import { StyleProps } from "../../utils/types";

interface PopoverProps
  extends Omit<AriaPopoverProps, "popoverRef">,
    StyleProps<"wrapper" | "underlay"> {
  state: OverlayTriggerState;
  children: React.ReactNode;
  popoverRef?: React.RefObject<HTMLDivElement>;
}

export function InternalPopover({
  state,
  children,
  popoverRef,
  style,
  styles,
  classNames,
  className,
  ...props
}: PopoverProps) {
  const internalPopoverRef = React.useRef(null);

  const theme = useTheme();

  const { popoverProps, underlayProps } = usePopover(
    { ...props, popoverRef: internalPopoverRef },
    state
  );

  const { style: internalStyle, ...otherPopoverProps } = popoverProps;

  return (
    <Overlay>
      <div
        {...underlayProps}
        style={styles?.underlay}
        className={cx(["underlay", classNames?.underlay])}
      ></div>
      <div
        data-color={theme?.color}
        data-radius={theme?.radius}
        ref={mergeRefs(popoverRef, internalPopoverRef)}
        className={cx(["p-popover", className, classNames?.wrapper])}
        style={{ ...internalStyle, ...style, ...styles?.wrapper }}
        {...otherPopoverProps}
      >
        {children}
      </div>
    </Overlay>
  );
}
